import React, { Component } from "react";
import { FirestoreCollection, withFirestore } from "react-firestore";
import distanceInWordsToNow from "date-fns/distance_in_words_to_now";

import Link from "./Link";

const PublicLinksPage = ({ links }) => {
  if (links.length === 0) return "0 links :(";

  return (
    <div className="list-group">
      {links.map(
        ({ url, id, title, favIconUrl, description, archivedAt }, index) => (
          <a
            key={id}
            href={url}
            target="_blank"
            className="list-group-item list-group-item-action flex-column align-items-start"
          >
            <div className="d-flex w-100 justify-content-between">
              <h5 className="mb-1">
                <img src={favIconUrl} style={{ width: 16, marginRight: 4 }} />{" "}
                {title}
              </h5>
              <small>{distanceInWordsToNow(archivedAt)} ago</small>
            </div>
            <p className="mb-1">{description}</p>
            <small>{url}</small>
          </a>
        )
      )}
    </div>
  );
};

const PublicLinksPageWithFirestore = withFirestore(PublicLinksPage);

export default () => (
  <FirestoreCollection
    path={"links"}
    limit={50}
    filter={["archivedAt", "<=", new Date()]}
    sort="archivedAt:desc"
    render={({ isLoading, data }) => {
      if (isLoading) return "Loading...";
      return <PublicLinksPageWithFirestore links={data} />;
    }}
  />
);



// WEBPACK FOOTER //
// ./src/PublicLinksPage.js